import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FileManagement from "./pages/fileManagement/FileManagement";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<FileManagement />} />
                <Route path="/fileManagement" element={<FileManagement />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
